import mainNav from './modules/main-nav';

document.addEventListener('DOMContentLoaded', () => {
	mainNav();

	// Prevent empty links
	const links = document.querySelectorAll('a[href="#"]');
	links.forEach((el) => {
		const link = el;
		link.onclick = (e) => {
			e.preventDefault();
		};
	});
});
